import React from 'react';
import { Stepper, Step, StepLabel, Typography, Box } from '@mui/material';

const steps = [
  { label: 'Step 01', description: "Handpick an interesting Domain"},
  { label: 'Step 02', description: 'carry down a related literature' },
  { label: 'Step 03', description: 'Bring the motivates and purpose' },
  { label: 'Step 04', description: 'Enrich the problem statement' },
  { label: 'Step 05', description: 'Sketch up the mind up' },
  { label: 'Step 06', description: 'Make an exprimental design' },
  
];

// Custom StepIcon Component
const CustomStepIcon = (props: { icon: React.ReactNode }) => {
  const { icon } = props;
  return (
    <Box
      sx={{
        width: 25,
        height: 25,
        borderRadius: '50%',
        backgroundColor: '#f97316',
        color: '#fff',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '14px',
        
      }}
      className='component'
    >
      {icon}
    </Box>
  );
};

const ServiceStepper = () => {
  return (
    <Stepper orientation="vertical" sx={{ background: 'transparent' }}>
      {steps.map((step, index) => (
        <Step key={index} active={true}>
          <StepLabel StepIconComponent={() => <CustomStepIcon icon={index + 1} />}>
            <Typography variant="h6" className='component'>{step.label}</Typography >
            <Typography variant="body2" sx={{fontWeight:"bold"}} className='component'>{step.description}</Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default ServiceStepper;
